import { render, staticRenderFns } from "./TradeRequestEvents.vue?vue&type=template&id=3e273efa"
import script from "./TradeRequestEvents.vue?vue&type=script&lang=js"
export * from "./TradeRequestEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports